import { Helmet } from "react-helmet-async";

const GlobalLayout = ({ title, description, keywords, children }) => {
  return (
    <>
    <Helmet>
        <title>{title}</title>
        <meta name="charset" content="utf-8" />
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
        <meta name="description" content={description || title} />
        <meta name="keywords" content={`court.gov.tm, ${keywords}`} />
        <meta name="author" content="court.gov.tm" />
    </Helmet>
    <main>{children}</main>
</>
  )
}

export default GlobalLayout